'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (ev) {
  var event = angular.copy(ev);
  var name = event.name + ' - ';

  if (event.level) {
    name = name + ' ' + event.level;
  }

  name = name + ' ' + (event.adults ? 'Adults' : event.age) + ' ' + event.event;

  event.$$name = name;

  return event;
};


//////////////////
// WEBPACK FOOTER
// ./events/deserialize.js
// module id = 480
// module chunks = 0